import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PagePayload } from '@core/interface/core';
import {
  AddHolidayTypeResponse,
  HolidayTypePayload,
  HolidayTypeResponse,
} from '@core/interface/holiday-type';
import { environment } from '@environment/environment';

@Injectable({
  providedIn: 'root',
})
export class HolidayTypeService {
  constructor(private http: HttpClient) {}

  getHolidayTypes(filter?: PagePayload) {
    let httpParams = new HttpParams();
    if (filter)
      Object.keys(filter).forEach((key) => {
        httpParams = httpParams.set(
          key,
          (filter[key as keyof PagePayload] as any) || ''
        );
      });
    return this.http.get<HolidayTypeResponse>(
      environment.endPoints.holidayTypeList,
      {
        params: httpParams,
      }
    );
  }
  addHolidayType(data: HolidayTypePayload) {
    return this.http.post<AddHolidayTypeResponse>(
      environment.endPoints.holidayTypeAddEdit,
      data
    );
  }
}
